import { useCallback, useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { AlertTriangle } from 'lucide-react';

export const AmountMismatchAlert = () => {
  const [items, setItems] = useState([]);
  const [notes, setNotes] = useState({});
  const load = useCallback(() => {
    api.get('/admin/payments/amount-mismatches', { params: { review_status: 'open' } })
      .then(r => setItems(r.data.items || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const review = async (m) => {
    const key = `${m.reference}/${m.wompi_transaction_id}`;
    try {
      await api.post(`/admin/payments/amount-mismatches/${encodeURIComponent(m.reference)}/${encodeURIComponent(m.wompi_transaction_id)}/review`, { note: notes[key] || '' });
      toast.success('Conciliación registrada');
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo registrar'); }
  };

  if (!items.length) return null;
  return (
    <div className="mt-6 border border-rose-300 bg-rose-50 p-4" data-testid="amount-mismatch-alert">
      <div className="flex items-center gap-2 font-bold text-rose-800 text-sm">
        <AlertTriangle className="h-4 w-4" /> {items.length} pago(s) Wompi con monto o moneda distintos — pendientes de conciliación manual
      </div>
      <p className="text-xs text-rose-700 mt-1">Estos pagos siguen pendientes: no se marcaron como pagados ni generaron pedidos o desembolsos.</p>
      <div className="mt-3 space-y-2">
        {items.map(m => {
          const key = `${m.reference}/${m.wompi_transaction_id}`;
          return (
            <div key={key} className="bg-white border border-rose-200 p-2 text-xs flex flex-wrap items-center gap-3" data-testid={`amount-mismatch-${m.reference}`}>
              <span className="font-mono">{m.reference}</span>
              <span>Esperado: <b>{(m.expected_cents / 100).toLocaleString('es-CO')} COP</b></span>
              <span>Wompi: <b>{m.received_cents ?? '—'} centavos {m.currency || 'sin moneda'}</b></span>
              <span className="font-mono text-slate-500">txn {m.wompi_transaction_id}</span>
              <Input className="h-7 w-56 text-xs rounded-none" placeholder="Nota de conciliación"
                value={notes[key] || ''} onChange={e => setNotes({ ...notes, [key]: e.target.value })}
                data-testid={`amount-mismatch-note-${m.reference}`} />
              <Button size="sm" className="h-7 rounded-none" disabled={!(notes[key] || '').trim()}
                onClick={() => review(m)} data-testid={`amount-mismatch-review-${m.reference}`}>Marcar conciliado</Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
